import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {io, Socket} from "socket.io-client";
import {environment} from "../../environments/environment";
import {LocalStorage} from "./appstate/storage/local-storage";

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  pushNotificationRealtime: Subject<any> = new BehaviorSubject(null);
  ordersRealtime: Subject<any> = new BehaviorSubject(null);
  deliversRealtime: Subject<any> = new BehaviorSubject(null);
  refundCheckPaymentsRealtime: Subject<any> = new BehaviorSubject(null);

  private readonly socket: Socket | null;
  private readonly isBrowser: boolean;

  channels = [
    {
      path: "CHANNEL_EVENT:PLATFORM_NOTIFICATIONS",
      subject: this.pushNotificationRealtime
    },
    {
      path: "CHANNEL_EVENT:ORDER_ACTIVITY",
      subject: this.ordersRealtime
    },
    {
      path: "CHANNEL_EVENT:DELIVER_AVAILABILITY_STATUS",
      subject: this.deliversRealtime
    },
    {
      path: "CHANNEL_EVENT:CHECK_NEED_REFUND",
      subject: this.refundCheckPaymentsRealtime
    },
  ]

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    // Socket.io and browser storage are not available during SSR.
    if (!this.isBrowser) {
      this.socket = null;
      return;
    }

    this.socket = io(environment.API_ENDPOINT, {autoConnect: true});
    if (!this.socket.connected) {
      this.initSocketConnection();
    }
  }

  initSocketConnection() {
    if (!this.socket) {
      return;
    }

    const token = LocalStorage.getToken();

    let headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    }

    this.socket.auth = {
      headers: headers,
      Authorization: token,
    };

    this.socket.connect();

    this.channels.forEach(
      value => {
        this.socket.on(value.path, (message: any) => {
          value.subject.next(message);
        });
      }
    );

    this.socket.on('disconnect', () => {
      console.log('Disconnected from server socket-io'.toUpperCase());
    });

    this.socket.on('connected', () => {
      console.log('Connected to server socket-io'.toUpperCase());
    });

    this.socket.on('error', (e: any) => {
      console.log(e);
    });

    this.socket.emit('info', 'application connected');

  }

  getPushNotificationRealtime(): Observable<any> {
    return this.pushNotificationRealtime.asObservable();
  }

  getOrdersRealtime(): Observable<any> {
    return this.ordersRealtime.asObservable();
  }

  getDeliversRealtime(): Observable<any> {
    return this.deliversRealtime.asObservable();
  }

  getRefundCheckPaymentsRealtime(): Observable<any> {
    return this.refundCheckPaymentsRealtime.asObservable();
  }

  disconnectAllSockets() {
    this.socket?.disconnect();
  }

}
